import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles, Typography } from '@material-ui/core';
import { LongString } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 2),
    margin: theme.spacing(-2, -2, 2, -2)
  },
  hintLabel: {
    fontWeight: theme.typography.fontWeightBold,
    marginRight: theme.spacing(0.5)
  }
}));

const ResumeCardUserHint = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        variant="body2"
        component="span"
        className={classes.hintLabel}
      >
        <FormattedMessage id="resumeCard.hint" />
      </Typography>
      <Typography variant="body2" component="span">
        <LongString>
          <FormattedMessage id="resumeCard.userHint" />
        </LongString>
      </Typography>
    </div>
  );
};

export default ResumeCardUserHint;
